export default "__VITE_ASSET__565aba3b__"